import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'vds-submenu-mobile',
  styleUrl: 'vds-submenu-mobile.scss',
  shadow: true,
})
export class VdsSubmenuMobile {

  render() {
    return (
      <Host>
        <div class="flex flex-col h-full">
          <div class="overflow-auto bg-white flex-1 px-[20px] pb-[10px]">
            <div class="flex flex-wrap">
              <ul class="w-full list-none">
                <slot name="nav-item"></slot>
              </ul>
              <ul class="mt-[25px] flex flex-wrap flex-col py-[11px]">
                <slot name="icon-link-item"></slot>
                <slot name="icon-link-dropdown-item"></slot>
              </ul>
            </div>
          </div>
          <div class="bg-white px-[20px] pt-[10px] pb-[25px] border-t border-grey-lighter">
            <div class="flex flex-wrap justify-between">
              <slot name="social-icon"></slot>
            </div>
          </div>
        </div>
      </Host>
    );
  }

}
